import React, { FC, ReactNode, useState } from "react";

import Navbar from "../../components/modules/Navbar";
import Sidebar from "../../components/modules/Sidebar";

type BaseLayoutProps = {
  children: ReactNode;
};

const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleOpenSidebar = () => setIsSidebarOpen(true);
  const handleCloseSidebar = () => setIsSidebarOpen(false);

  return (
    <>
      <Navbar handleOpenSidebar={handleOpenSidebar} />
      <Sidebar isOpen={isSidebarOpen} handleClose={handleCloseSidebar} />
      {children}
    </>
  );
};

export default BaseLayout;
